/**
 * @module views\mdl\routing
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";

@Component
export default class Routing extends GhBase {
  private tabs: IGhTab[] = [
    { title: "工艺管理", drawer: false },
    { title: "工艺文件查看" }
  ];
  private curentMaterialType = {};

  private current: IndexObject = { File: "" };

  private template = {
    File: "",
    Seq: 0,
    Name: "",
    Cd: ""
  };

  private viewItem(item) {
    this.current = item;
  }

  private args = { keyword: "" };
}
